export interface HoaDonBanHangTableTabConfig {
  key: string;
  name: string;
  status?: string;
  color?: string;
}

export const TABLE_PAGE_SIZE = 500;

export const HOA_DON_BAN_HANG_TABLE_TABS: HoaDonBanHangTableTabConfig[] = [
  {
    key: 'all',
    name: 'Tất cả'
  },
  {
    key: 'draft',
    name: 'Lập chứng từ',
    status: '0',
    color: '#EAD1DC'
  },
  {
    key: 'pending',
    name: 'Chờ duyệt',
    status: '3',
    color: '#ef4444'
  },
  {
    key: 'deleted-invoice',
    name: 'Xuất hóa đơn',
    status: '5',
    color: '#3D85C6'
  },
  {
    key: 'cancelled',
    name: 'Hủy',
    status: '9',
    color: '#6B7280'
  },
  {
    key: 'other',
    name: 'Khác',
    status: '99',
    color: '#000000'
  }
];
